<label class="crtw-text-black crtw-text-sm crtw-text-left crtw-leading-1 crtw-pb-2" {...$$restProps}>
  <slot />
</label>
